import { TextSizes, Text } from '@afterpaytouch/core'
import React, { FunctionComponent } from 'react'
import { useTranslation } from '../../utils/convergence'

export const ToastMessage: FunctionComponent<{ headingSize: TextSizes; context: string; amount: string }> = ({ headingSize, context, amount }) => {
  const { t } = useTranslation()
  return (
    <>
      <Text size={headingSize} bold testNameSpace='payment-schedule-toast-heading'>
        {t('common:toastHeading', { context, amount })}
      </Text>
      <Text size='XS' testNameSpace='payment-schedule-toast-notification'>
        {t('common:toastNotification', { context })}
      </Text>
    </>
  )
}
